export default __webpack_public_path__ + "static/media/NIHARIKA.586f7462.JPG";